<template>
  <div class="topic-answer-wrap">
    <Loading v-if="!listHtml" class="answer-loading" />
    <ComNull v-else-if="!listHtml.length" desc="暂无答案" />
    <div class="topic-wrap">
      <div class="topic-item" v-for="(item, index) in listHtml" v-html="item" :key="index" />
    </div>
  </div>
</template>
<script>
// import MockXuanZe from '@aixuexi/tksdk/topicRender/mocks/xuanze'
// import MockTianKong from '@aixuexi/tksdk/topicRender/mocks/tiankong'
// import MockPanDuan from '@aixuexi/tksdk/topicRender/mocks/panduan'
// import MockZongHe from '@aixuexi/tksdk/topicRender/mocks/zonghe'
// import MockLianCiCJ from '@aixuexi/tksdk/topicRender/mocks/lianCiCJ'
// import MockLianXian from '@aixuexi/tksdk/topicRender/mocks/lianxian'
// import MockLianXianChild from '@aixuexi/tksdk/topicRender/mocks/lianxian-child'
// import MockXuanCiTK from '@aixuexi/tksdk/topicRender/mocks/xuanCiTK'
// import MockXuanCiTKtk from '@aixuexi/tksdk/topicRender/mocks/xuanCiTK-tk'
// import MockYueDuLJ from '@aixuexi/tksdk/topicRender/mocks/yueDuLJ'
// import MockYueDuLJxz from '@aixuexi/tksdk/topicRender/mocks/yueDuLJ-zh'
// import MockYueDuLJpd from '@aixuexi/tksdk/topicRender/mocks/yueDuLJ-pd'
// import MockWanXingTK from '@aixuexi/tksdk/topicRender/mocks/wanXingTK'
// import MockJieDa from '@aixuexi/tksdk/topicRender/mocks/jieDa'
import { tkSdkNew } from '@/utils/tools.js'
import Loading from '@/components/Loading.vue'
import ComNull from '@/components/ComNull/ComNull.vue'
export default {
  components: {
    Loading,
    ComNull
  },
  mounted() {
    // demo
    // this.topicRender([
    //   MockXuanZe,
    //   MockTianKong,
    //   MockPanDuan,
    //   MockZongHe,
    //   MockLianCiCJ,
    //   MockLianXian,
    //   MockLianXianChild,
    //   MockXuanCiTK,
    //   MockXuanCiTKtk,
    //   MockYueDuLJ,
    //   MockYueDuLJxz,
    //   MockYueDuLJpd,
    //   MockWanXingTK,
    //   MockJieDa
    // ])
  },
  data() {
    return {
      listHtml: null
    }
  },
  methods: {
    topicRender(data) {
      this.listHtml = data.map((item, index) => {
        var fragment = document.createDocumentFragment()
        var div = document.createElement('div')
        const tkSdkResult = tkSdkNew.render(item, {
          polyvSetting: {
          }
        })
        const resultHtml = tkSdkResult.TPL.getContent()
        div.innerHTML = `
        <span class='xkh-teacher-topic-num'>${index + 1}题</span>
        ${resultHtml}
        `
        fragment.appendChild(div)
        // 去掉题干，只保留小题序号
        Array.from(fragment.lastChild.querySelectorAll('.tksdk_topic')).forEach(item => {
          const topicIndex = item.querySelector('.trzh-topic-index')
          const trContent = item.querySelector('.tr-content')
          const numMatch = trContent.innerHTML.trim().match(/(\(*[0-9]+\)*\.*&nbsp)/)
          // 去掉题干
          if (numMatch && numMatch.length) {
            item.innerHTML = numMatch[0]
          } else if (topicIndex) {
            item.innerHTML = topicIndex.innerHTML
          } else {
            item.innerHTML = ''
          }
        })
        // 去掉选项
        Array.from(fragment.lastChild.querySelectorAll('.tksdk_options')).forEach(item => {
          item.remove()
        })
        Array.from(fragment.lastChild.querySelectorAll('.tr-aj-title')).forEach(item => {
          item.remove()
        })
        // 去掉题目与解析 title
        Array.from(fragment.lastChild.querySelectorAll('.tr-aj-title')).forEach(item => {
          item.remove()
        })
        // 去掉视频解析
        Array.from(fragment.lastChild.querySelectorAll('.icn_video-box-solt')).forEach(item => {
          item.remove()
        })
        // 去掉题解析
        Array.from(fragment.lastChild.querySelectorAll('.icn_jiexi-box-solt')).forEach(item => {
          item.remove()
        })
        return fragment.firstChild.innerHTML
      })
    }
  }
}
</script>
<style lang="less" scoped>
.topic-answer-wrap {
  height: 100%;
  overflow: hidden;
}
.topic-wrap {
  overflow-y: auto;
  height: 100%;
  .topic-item {
    background: #F8FAFD;
    margin-bottom: 16px;
  }
  :deep(.xkh-teacher-topic-num) {
    color: #f3a02e;
    font-weight: 700;
    font-size: 16px;
    padding: 8px;
    display: inline-block;
  }
}
</style>